
import React, { useEffect, useState } from 'react';
import {DiaryRootState} from "appRoot/rootReducer";
import { useSelector } from 'react-redux';

const NS = 'ResizeBackgroundPanel';

/**
 * Note: the purpose of thie component is just to create a smooth transition, in sync with the booking card list drawer
 */
export default function ResizeBackgroundPanel() {
  // prettier-ignore
  const width = useSelector((state: DiaryRootState) => state.resizerReducer.width);

  const [panelWidth, setPanelWidth] = useState(0);

  useEffect(() => {
    setPanelWidth(width)
  }, [width])

  return (
      <div style={{
        minWidth: panelWidth,
        transition: `min-width 0.3s`,
        willChange: 'min-width'
      }}></div>
  )
}

